import { render, staticRenderFns } from "./TerminalAdsFooter.vue?vue&type=template&id=32f62078&scoped=true"
import script from "./TerminalAdsFooter.vue?vue&type=script&lang=js"
export * from "./TerminalAdsFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f62078",
  null
  
)

export default component.exports